<template>
  <div>
    <div class="form-group">
      <label>Content</label>
      <WysiwygEditor v-model="content" />
    </div>

    <textarea
      id="setting-wysiwyg-saved-content"
      name="setting[value]"
      v-model="content"
      style="display: none;"
    ></textarea>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import WysiwygEditor from './components/WysiwygEditor.vue'

export default {
  components: { WysiwygEditor },
  setup() {
    const content = ref('');

    onMounted(() => {
      const el = document.getElementById('setting-wysiwyg-initial-content');
      if (el) {
        try {
          let raw = JSON.parse(el.textContent || el.innerText || '""');
          const tmp = document.createElement('textarea');
          tmp.innerHTML = raw;
          content.value = tmp.value || tmp.innerHTML;
        } catch (e) {
          content.value = '';
        }
      }
    });

    return { content };
  }
};
</script>
